import { sbaAxios } from "../utils/sbaAxios";
import { getInvestorTracking,getTrackingtransactionTypes,getInvestorPortfolio,getInvestorAsset,getInvestorStatus } from "../../config/apiConfig";
import {
    FETCH_INVESTORTRACKING_BEGIN,
    FETCH_INVESTORTRACKING_SUCCESS,
    FETCH_INVESTORTRACKING_FAILURE,
    FETCH_INVESTORTRACKINGTRANSACTIONTYPE_BEGIN,
    FETCH_INVESTORTRACKINGTRANSACTIONTYPE_SUCCESS,
    FETCH_INVESTORTRACKINGTRANSACTIONTYPE_FAILURE,
    FETCH_INVESTORTRACKINGPORTFOLIO_BEGIN,
    FETCH_INVESTORTRACKINGPORTFOLIO_SUCCESS,
    FETCH_INVESTORTRACKINGPORTFOLIO_FAILURE,
    FETCH_INVESTORTRACKINGASSET_BEGIN,
    FETCH_INVESTORTRACKINGASSET_SUCCESS,
    FETCH_INVESTORTRACKINGASSET_FAILURE,
    FETCH_INVESTORTRACKINGSTATUS_BEGIN,
    FETCH_INVESTORTRACKINGSTATUS_SUCCESS,
    FETCH_INVESTORTRACKINGSTATUS_FAILURE,
  } from '../constants/investorTracking';


export const getInvestorTrackingList=(investortrackingId,familyIds,portfolioIds,assetIds,statsIds,transactiontypeIds,fromDate,toDate,groupId,tbd)=> {
  return (dispatch) => {
      dispatch(fetchInvestorTrackingBegin());
      sbaAxios({
          url: `${getInvestorTracking}?investorTrackingId=${investortrackingId}&familyIdList=${familyIds}&portfolioIdList=${portfolioIds}&assetIdList=${assetIds}&statsIdList=${statsIds}&transactionTypeIdList=${transactiontypeIds}&fromDate=${fromDate}&toDate=${toDate}&transactionGroupId=${groupId}&tbd=${tbd}`,
          method: 'get',
      })
      .then((repos) => {
        const List = repos;
        //Add logic to format the DataItem if needed using map
        dispatch(fetchInvestorTrackingSuccess(List));
        return List;
      })
      .catch((error) => {return dispatch(fetchInvestorTrackingFailure(error))});
  };
}

export const fetchInvestorTrackingBegin = () => ({
  type:  FETCH_INVESTORTRACKING_BEGIN,
});

export const fetchInvestorTrackingSuccess = (investortrackingList) => ({
  type: FETCH_INVESTORTRACKING_SUCCESS,
  payload: {investortrackingList},
});


export const fetchInvestorTrackingFailure = (errorMessage) => ({
  type: FETCH_INVESTORTRACKING_FAILURE,
  payload: {errorMessage}
});

// Get Transaction Types...

export const getTransactionTypes=()=> {
  return (dispatch) => {
      dispatch(fetchTransactionTypeBegin());
      sbaAxios({
          url: `${getTrackingtransactionTypes}`,
          method: 'get',
      })
      .then((repos) => {
        const transactionTypes = repos;
        //Add logic to format the DataItem if needed using map
        dispatch(fetchTransactionTypeSuccess(transactionTypes));
        return transactionTypes;
      })
      .catch((error) => {return dispatch(fetchTransactionTypeFailure(error))});
  };
}

export const fetchTransactionTypeBegin = () => ({
  type:  FETCH_INVESTORTRACKINGTRANSACTIONTYPE_BEGIN,
});

export const fetchTransactionTypeSuccess = (transactionTypes) => ({
  type: FETCH_INVESTORTRACKINGTRANSACTIONTYPE_SUCCESS,
  payload: {transactionTypes},
});


export const fetchTransactionTypeFailure = (errorMessage) => ({
  type: FETCH_INVESTORTRACKINGTRANSACTIONTYPE_FAILURE,
  payload: {errorMessage}
});

// Get portfolio..

export const getInvestorPortfolioAction=(FamilyIds,FromDate,ToDate)=> {
  return (dispatch) => {
      dispatch(fetchInvestorPortfolioBegin());
      sbaAxios({
          url: `${getInvestorPortfolio}?familyIdList=${FamilyIds}&onlyWithInvTrackingTrans=true&transactionsFromDate=${FromDate}&transactionsToDate=${ToDate}`,
          method: 'get',
      })
      .then((repos) => {
        const portfolios = repos;
        //Add logic to format the DataItem if needed using map
        dispatch(fetchInvestorPortfolioSuccess(portfolios));
        return portfolios;
      })
      .catch((error) => {return dispatch(fetchInvestorPortfolioFailure(error))});
  };
}

export const fetchInvestorPortfolioBegin = () => ({
  type:  FETCH_INVESTORTRACKINGPORTFOLIO_BEGIN,
});

export const fetchInvestorPortfolioSuccess = (investorPortfolio) => ({
  type: FETCH_INVESTORTRACKINGPORTFOLIO_SUCCESS,
  payload: {investorPortfolio},
});


export const fetchInvestorPortfolioFailure = (errorMessage) => ({
  type: FETCH_INVESTORTRACKINGPORTFOLIO_FAILURE,
  payload: {errorMessage}
});
// Get Assets..

export const getInvestorAssetAction=(FamilyIds,PortfolioIds,FromDate,ToDate)=> {
  return (dispatch) => {
      dispatch(fetchInvestorAssetBegin());
      sbaAxios({
          url: `${getInvestorAsset}?familyIdList=${FamilyIds}&portfolioIdList=${PortfolioIds}&onlyWithInvTrackingTrans=true&transactionsFromDate=${FromDate}&transactionsToDate=${ToDate}`,
          method: 'get',
      })
      .then((repos) => {
        const Assets = repos;
        //Add logic to format the DataItem if needed using map
        dispatch(fetchInvestorAssetSuccess(Assets));
        return Assets;
      })
      .catch((error) => {return dispatch(fetchInvestorPortfolioFailure(error))});
  };
}

export const fetchInvestorAssetBegin = () => ({
  type:  FETCH_INVESTORTRACKINGASSET_BEGIN,
});

export const fetchInvestorAssetSuccess = (investorAssets) => ({
  type: FETCH_INVESTORTRACKINGASSET_SUCCESS,
  payload: {investorAssets},
});


export const fetchInvestorAssetFailure = (errorMessage) => ({
  type: FETCH_INVESTORTRACKINGASSET_FAILURE,
  payload: {errorMessage}
});
// Get Status...

export const getinvestorstatusAction=()=> {
  return (dispatch) => {
      dispatch(fetchInvestorStatusBegin());
      sbaAxios({
          url: `${getInvestorStatus}`,
          method: 'get',
      })
      .then((repos) => {
        const Status = repos;
        //Add logic to format the DataItem if needed using map
        dispatch(fetchInvestorStatusSuccess(Status));
        return Status;
      })
      .catch((error) => {return dispatch(fetchInvestorStatusFailure(error))});
  };
}

export const fetchInvestorStatusBegin = () => ({
  type:  FETCH_INVESTORTRACKINGSTATUS_BEGIN,
});

export const fetchInvestorStatusSuccess = (investorStatus) => ({
  type: FETCH_INVESTORTRACKINGSTATUS_SUCCESS,
  payload: {investorStatus},
});


export const fetchInvestorStatusFailure = (errorMessage) => ({
  type: FETCH_INVESTORTRACKINGSTATUS_FAILURE,
  payload: {errorMessage}
});